import { Link } from "wouter";
import { Compass } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ErrorPage } from "@/components/waggle/ErrorPage";
import { useAuth } from "@/context/AuthContext";

export default function NotFound() {
  const { user, isLoading } = useAuth();
  // /dashboard is protected, so while auth is still loading a signed-out user
  // is bounced to Login anyway.
  const homePath = user || isLoading ? "/dashboard" : "/";

  return (
    <ErrorPage
      data-testid="not-found-page"
      icon={<Compass />}
      eyebrow="404"
      title="We couldn't find that page"
      description="The link may be old or mistyped. Your tests are safe."
      actions={
        <Button asChild>
          <Link href={homePath} data-testid="button-go-home">
            Go home
          </Link>
        </Button>
      }
    />
  );
}
